import React from 'react';
import { Link } from 'react-router-dom';

import EmptyView from 'components/EmptyView';
import { projectType } from 'types';

export const NoTestSets = ({ project }) => (
  <EmptyView>
    <p>You don&apos;t have any test sets yet.</p>
    <p>
      Click{' '}
      <Link to={`/${project.account}/${project.slug}/test-sets`}>here</Link> to
      create new!
    </p>
  </EmptyView>
);

NoTestSets.propTypes = {
  project: projectType.isRequired,
};

export default NoTestSets;
